/* eslint-disable  */
//@ts-nocheck
import React from 'react';
import { browserHistory } from 'react-router';
import _ from 'underscore';

import auth from './auth';
import ajax from './ajax';
import helpers from './helpers';
import { useQuery } from '@apollo/client';
import * as enums from '@playbook-technologies/common-enums';
import MultipleExerciseEdit from './MultipleExerciseEdit';
import SingleExerciseEdit from './SingleExerciseEdit';
import ClassExerciseEdit from './ClassExerciseEdit';
import YouTubeExerciseEdit from './YouTubeExerciseEdit';
import ProductExerciseEdit from './ProductExerciseEdit';
import NutritionExerciseEdit from './NutritionExerciseEdit';
import Header from './Header';
import Aside from './Aside';
import StatusBar from './StatusBar';
import { GET_INFLUENCER } from '../api/graphql/query';
import createClass from 'create-react-class';
import { Typography } from '@mui/material';
import { PrimaryButton, SecondaryButton } from '@client/new/components/button';

const ExerciseTemplateEdit = createClass({
  getInitialState() {
    return {
      template: null,
      influencerId: this.getInfluencerId(),
      message: 'Loading...',
      isModified: false,
      isSaving: false,
      isUploadingMedia: false,
    };
  },
  removeVideo() {
    const oldTemplate = this.state.template.template;
    this.setState({
      template: {
        name: '',
        type: 4,
        template: {
          description: '',
          name: '',
          type: 4,
          youtubeId: oldTemplate.youtubeId,
        },
      },
    });
  },
  componentWillMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  },
  routerWillLeave() {
    if (this.state.isModified && !this.state.isSaving) {
      return 'There are pending changes to the Library item, are you sure you want to leave without saving?';
    }
  },
  async componentDidMount() {
    this.getExerciseTemplate();
  },
  getExerciseTemplate() {
    if (this.props.params.id === 0 || this.props.params.id === '0') {
      var template = null;

      if (this.props.params.exerciseType) {
        template = {
          name: '',
          type: parseInt(this.props.params.exerciseType),
          template: helpers.generateExercise(this.props.params.exerciseType),
        };
      }
      this.setState({
        template: template,
        message: '',
        isModified: false,
        isSaving: false,
        isUploadingMedia: false,
      });
      return;
    } else if (this.props.params.id) {
      ajax
        .getExerciseTemplate(this.props.params.id)
        .then((et) => {
          //console.log('[ExerciseTemplateEdit] Fetched ExerciseTemplate data.', workout);
          this.setState({
            template: et,
            message: '',
            isModified: false,
            isSaving: false,
          });
        })
        .catch((e) => {
          console.log('Something went wrong', e);
          if (e === 'auth') {
            auth.logout();
          }
          this.setState({
            template: null,
            message: 'You may be experiencing connectivity issues.',
            isModified: false,
            isSaving: false,
          });
        });
    }
  },
  getInfluencerId() {
    return this.props.params.influencerId
      ? this.props.params.influencerId
      : auth.getUser().influencerId;
  },
  goBack() {
    return browserHistory.push(
      `/admin/partner/${this.getInfluencerId()}/exercise-library`,
    );
  },
  submit() {
    if (this.state.isUploadingMedia) {
      StatusBar.sendErrorMessage(
        'Video processing in progress. Please wait until the processing is complete to save your edits',
      );
      return;
    }

    this.setState({
      isSaving: true,
    });

    //console.log('[ExerciseTemplateEdit] Submit called and prepared', this.state.template);

    let preparedTemplate = helpers.prepareExercise(
      this.state.template.template,
    );
    if (!preparedTemplate.name) {
      StatusBar.sendErrorMessage(
        'Could not save exercise to Library, please make sure your exercise has a name.',
      );
      this.setState({ buttonState: this.states.Default });
      return;
    }

    if (this.state.template.id) {
      preparedTemplate.id = this.state.template.id;
    }

    if (this.state.template.type === 4) {
      preparedTemplate.videoId = preparedTemplate.id;
      delete preparedTemplate.id;
    }

    ajax
      .upsertExerciseTemplate({
        influencerId: this.getInfluencerId(),
        template: preparedTemplate,
      })
      .then(() => {
        console.log('Saved ExerciseTemplate.');
        browserHistory.push(
          `/admin/partner/${this.getInfluencerId()}/exercise-library`,
        );
      })
      .catch((e) => {
        console.log('[InfluencerEdit] Error upserting Workout.', e);
        this.setState({
          isSaving: false,
        });
        if (!preparedTemplate.name) {
          StatusBar.sendErrorMessage(
            'Could not save exercise to Library, please make sure your exercise has a name.',
          );
        } else {
          StatusBar.sendErrorMessage(
            "You're experiencing connection issues, please try again.",
          );
        }
      });
  },
  merge(id, newData) {
    //console.log('merge called' { id, newData });
    var newTemplate = this.state.template;
    newTemplate.template = _.extend(newTemplate.template, newData);

    this.setState({
      // editors return data in shape of (execiseId, data)
      template: newTemplate,
      isModified: true,
    });
  },
  delete() {
    this.setState({
      template: null,
      isModified: true,
    });
  },
  setUploadingMedia({ isUploading, id }) {
    this.setState({
      ...this.state,
      isUploadingMedia: isUploading,
    });
  },
  render() {
    console.log('[ExerciseTemplateEdit] render() called.', this.state.template);

    var component = null;
    if (this.state.template) {
      if (this.state.template.type == enums.Exercise.Type.Custom.value) {
        console.error(
          'Trying to render a Custom ExerciseTemplate.',
          this.state.template,
        );
        return;
      } else if (
        this.state.template.type == enums.Exercise.Type.Multiple.value
      ) {
        component = (
          <MultipleExerciseEdit
            id={0}
            data={this.state.template.template}
            onDelete={this.delete}
            exerciseLength={1}
            onChange={this.merge}
            deleteDisabled={true}
            minimizeDisabled={true}
            index={1}
            influencerId={this.getInfluencerId()}
            setUploadingMedia={this.setUploadingMedia}
          />
        );
      } else if (this.state.template.type == enums.Exercise.Type.Single.value) {
        component = (
          <SingleExerciseEdit
            id={0}
            influencerId={this.getInfluencerId()}
            data={this.state.template.template}
            onDelete={this.delete}
            exerciseLength={1}
            onChange={this.merge}
            deleteDisabled={true}
            minimizeDisabled={true}
            index={1}
            setUploadingMedia={this.setUploadingMedia}
          />
        );
      } else if (
        this.state.template.type == enums.Exercise.Type.YouTube.value
      ) {
        component =
          this.props.influencer.customizations.isNewVideo &&
          (this.state.template.template.youtubeId === '00000000000' ||
            this.state.template.template.youtubeId === '' ||
            !this.props.exercises[i].youtubeId) ? (
            <ClassExerciseEdit
              id={0}
              data={this.state.template.template}
              onDelete={this.delete}
              exerciseLength={1}
              onChange={this.merge}
              deleteDisabled={true}
              minimizeDisabled={true}
              onRemoveVideo={this.removeVideo}
              influencerId={this.getInfluencerId()}
              index={1}
            />
          ) : (
            <YouTubeExerciseEdit
              id={0}
              data={this.state.template.template}
              onDelete={this.delete}
              exerciseLength={1}
              onChange={this.merge}
              deleteDisabled={true}
              minimizeDisabled={true}
              index={1}
            />
          );
      } else if (
        this.state.template.type == enums.Exercise.Type.Product.value
      ) {
        component = (
          <ProductExerciseEdit
            id={0}
            data={this.state.template.template}
            onDelete={this.delete}
            exerciseLength={1}
            onChange={this.merge}
            deleteDisabled={true}
            minimizeDisabled={true}
            index={1}
          />
        );
      } else if (
        this.state.template.type == enums.Exercise.Type.Nutrition.value
      ) {
        component = (
          <NutritionExerciseEdit
            id={0}
            data={this.state.template.template}
            onDelete={this.delete}
            exerciseLength={1}
            onChange={this.merge}
            deleteDisabled={true}
            minimizeDisabled={true}
            index={1}
          />
        );
      }
    }
    var title = 'Define Exercise';
    if (
      this.state.template &&
      this.state.template.template &&
      this.state.template.template.name
    ) {
      title = this.state.template.template.name; //shit
    }

    return (
      <div className="workoutEdit exerciseTemplateEdit exercisesEdit">
        <Header>
          <Typography variant="h1">{title}</Typography>
          <div className="flex flex-row items-center gap-3">
            <div className="button-box save">
              <a>
                <PrimaryButton
                  disabled={this.state.isUploadingMedia}
                  onClick={this.submit}
                  ref="submit"
                >
                  Save
                </PrimaryButton>
              </a>
            </div>
            <a onClick={this.goBack}>
              <SecondaryButton>Cancel</SecondaryButton>
            </a>
          </div>
        </Header>
        <main id="main">
          <div>{component}</div>
          <br />
        </main>
        <StatusBar.Component />
      </div>
    );
  },
});

const ExerciseTemplateEditWrapper = (props) => {
  const influencerId = props.params.influencerId
    ? props.params.influencerId
    : auth.getUser().influencerId;

  const { data, loading } = useQuery(GET_INFLUENCER, {
    variables: { id: parseInt(influencerId) },
  });
  return (
    <ExerciseTemplateEdit
      isLoading={loading}
      influencer={data ? data.creator : null}
      {...props}
    />
  );
};

export default ExerciseTemplateEditWrapper;
